module.exports = __webpack_public_path__ + "img/img-registration-three@3x.3101a99c.png";